(() => {
  const STORAGE_KEY = "wishlist";
  const MAX_ITEMS = 16;

  const readWishlist = () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = JSON.parse(raw || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };

  const writeWishlist = (items) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  };

  const updateHeaderCount = () => {
    const count = readWishlist().length;
    document.querySelectorAll(".wishlist-h-count").forEach((el) => {
      el.textContent = String(count);
    });
  };

  const setButtonState = (button, added) => {
    button.setAttribute("aria-added", added ? "true" : "false");
  };

  const syncButtons = (root = document) => {
    const list = readWishlist();
    root.querySelectorAll(".wishlist-engine").forEach((btn) => {
      const handle = btn.getAttribute("data-product_handle");
      if (!handle) return;
      setButtonState(btn, list.includes(handle));
    });
  };

  const setAllButtonsForHandle = (handle, added, root = document) => {
    if (!handle) return;
    root
      .querySelectorAll(`.wishlist-engine[data-product_handle="${handle}"]`)
      .forEach((btn) => setButtonState(btn, added));
  };

  const toggleWishlist = (button) => {
    const handle = button.getAttribute("data-product_handle");
    if (!handle) return;
    const list = readWishlist();
    const index = list.indexOf(handle);
    let added = false;

    if (index >= 0) {
      list.splice(index, 1);
      added = false;
    } else {
      if (list.length >= MAX_ITEMS) {
        alert("Voce atingiu o limite maximo de 16 itens na lista.");
        return;
      }
      list.push(handle);
      added = true;
    }

    writeWishlist(list);
    setAllButtonsForHandle(handle, added);
    updateHeaderCount();

    if (window.location.pathname === "/pages/wishlist" && index >= 0) {
      const item = button.closest("li");
      if (item) item.remove();
    }
  };

  const wireButtons = (root = document) => {
    root.querySelectorAll(".wishlist-engine").forEach((btn) => {
      if (btn.dataset.wishlistBound === "true") return;
      btn.dataset.wishlistBound = "true";
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        toggleWishlist(btn);
      });
    });

    root.querySelectorAll(".share-toggle").forEach((btn) => {
      if (btn.dataset.shareBound === "true") return;
      btn.dataset.shareBound = "true";
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const container = btn.closest(".action-buttons")?.querySelector(".share-container");
        if (!container) return;
        container.style.display = container.style.display === "block" ? "none" : "block";
      });
    });
  };

  document.addEventListener("DOMContentLoaded", () => {
    syncButtons();
    wireButtons();
    updateHeaderCount();
  });

  // Expose a small hook for dynamic content
  window.FashionWishlist = { wireButtons, updateHeaderCount, syncButtons };
})();
